import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EntradaListarComponent } from './entrada-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: EntradaListarComponent }
    ])],
    exports: [RouterModule]
})
export class EntradaListarRoutingModule { }
